import React from 'react';
import {
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  AutoMode as AutoModeIcon,
} from '@mui/icons-material';
import { useThemeMode } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { themeMode, toggleTheme } = useThemeMode();
  const theme = useTheme();

  const getIcon = () => {
    switch (themeMode) {
      case 'light':
        return <LightModeIcon />;
      case 'dark':
        return <DarkModeIcon />;
      case 'auto':
        return <AutoModeIcon />;
      default:
        return <LightModeIcon />;
    }
  };

  const getTooltip = () => {
    switch (themeMode) {
      case 'light':
        return 'Switch to dark mode';
      case 'dark':
        return 'Switch to auto mode';
      case 'auto':
        return 'Switch to light mode';
      default:
        return 'Toggle theme';
    }
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          color: theme.palette.mode === 'dark' ? '#FF8A65' : theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' 
              ? 'rgba(255, 138, 101, 0.15)' 
              : 'rgba(255, 107, 53, 0.08)',
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;